import BaseService from "@/services/BaseService";
import {http} from "./config"

class CrmPropostaAtividadeService extends BaseService {
  constructor() {
    super("/v1/crm/proposta-atividades");
  }

  listar(data){
    return http.get(`/v1/crm/proposta-atividades?crm_proposta_id=${data.id}`)
  }
}

export default new CrmPropostaAtividadeService();
